import React from "react";

import "./LoadingSpinner.css";

const LoadingSpinner = (props) => {
  return (
    <div className={`
        ${props.asOverlay ? "loading-spinner__overlay" : ""}
        ${props.asAbsolute ? "loading-spinner__absolute" : ""} 
        ${props.asWhiteBg ? "loading-spinner__white_bg" : ""}
      `}>
      <div className="container-loading-spinner">
        <div className={props.noPadding ? "" : "loader"}>
          <svg
            id="loader"
            width="100%"
            height="100%"
            viewBox="0 0 83 80"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            xmlSpace="preserve"
            xmlnsserif="http://www.serif.com/"
            style={{
              fillRule: "evenodd",
              clipRule: "evenodd",
              strokeLinejoin: "round",
              strokeMiterlimit: "2",
            }}
          >
            <g transform="matrix(0.436167,0,0,0.437144,-5228.84,-3691.92)">
              <path
                d="M12081.9,8468.45L12012,8605.7L12042.7,8605.7L12085.2,8522.3L12124.4,8605.7L12154.7,8605.7L12089.9,8468.45L12081.9,8468.45Z"
                style={{ fill: "none", fillRule: "nonzero" }}
              />
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
